import { OpenDialogHelpComponent } from './../../dialog/open-dialog-help/open-dialog-help.component';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { faHeart as faHeartEmpty } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faHeartFull } from '@fortawesome/free-solid-svg-icons';
import { OpendialogLoginComponent } from 'app/components/dialog/open-dialog-login/opendialog-login.component';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { Color } from 'app/shared/models/class/color/color';
import { Notice } from 'app/shared/models/class/notice/notice';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { Tag } from 'app/shared/models/class/tags/tag';
import { WishList } from 'app/shared/models/class/wishlist/wishlist';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ColorService } from 'app/shared/services/color/color.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { NoticeService } from 'app/shared/services/notice/notice.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { TagService } from 'app/shared/services/tag/tag.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UniverseService } from 'app/shared/services/universe/universe.service';
import { WishlistService } from 'app/shared/services/wishlist/wishlist.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import  * as moment from 'moment';


@Component({
  selector: 'app-offer-home',
  templateUrl: './offer-home.component.html',
  styleUrls: ['./offer-home.component.scss']
})

export class OfferHomeComponent extends SubscriptionBaseComponent implements OnInit {

  faHeartEmpty = faHeartEmpty;
  faHeartFull = faHeartFull;
  faheart!: object;

  searchForm!: UntypedFormGroup;

  tags: Tag[] = [];
  tagsSelected: Tag[] = [];
  initTagsSelected: Tag[] = [];

  offers: FullOffer[] = [];
  color: ThemePalette = 'primary';
  myWishes: FullOffer[] = [];
  widthScreen: number;
  load: boolean;
  userConnected!: InfosUser;
  moreTag = false;
  coordinatesSearch: any;
  valueInput: any;
  latitude: number = 0;
  longitude: number = 0;
  tagIds: any;

  filteredByClub = false;

  private static readonly DEMO_THEME_CLASS = 'demo';
  private static readonly DEMO_THEME_LIGHT = 'light';
  private static readonly DEMO_THEME_DARK = 'dark';

  public theme: string;
  colorTheme: string;
  colorsTag: Color[] = [];
  baseTags: any[] = [];
  clubSelected = '';

  universeSelected: string | number;
  listUniverses = [];
  isLoading: boolean;
  colorTag = '#fff !important';
  currentDate!: string;
  searchTxt!: string;
  listOffers: FullOffer[] = [];
  valueKM = 50;

  isDetailsImageOpen = false;
  notice!: Notice;
  tagsArray: number[] = [];
  includedTags = false;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly offerService: OfferService,
    private readonly dataService: DataService,
    private readonly cdr: ChangeDetectorRef,
    private readonly dialog: MatDialog,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly wishlistService: WishlistService,
    private readonly sessionBasketService: SessionBasketService,
    private readonly tagsService: TagService,
    private readonly colorService: ColorService,
    private readonly faIconService: FaiconService,
    private readonly universeService: UniverseService,
    private readonly uiService: UiService,
    private readonly noticeService: NoticeService,
    @Inject(DOCUMENT) private readonly document: Document
  )
  {
    super();
    this.theme = this.document.documentElement.classList.contains(OfferHomeComponent.DEMO_THEME_CLASS) ?
      OfferHomeComponent.DEMO_THEME_DARK : OfferHomeComponent.DEMO_THEME_LIGHT;
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('clubCodeForHomeOffers')) {
      this.filteredByClub = true;
      this.clubSelected = sessionStorage.getItem('clubCodeForHomeOffers')!;
    }
    this.checkDataParam();
    this.initComponent();
    this.initSub();
    this.initForm();
    this.getColorTags();

    if (this.authService.isAuth()) {
      this.getWishlist();
      this.getBasketlist();
    }

    this.widthScreen = window.innerWidth;
  }



  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  reductHeader() {
    const header = document.getElementById('hearder_home');
    if (header) {
      header.style.height = '100px';
    }
  }

  getId(tag: string): string {
    const newTag = tag.toLowerCase().split(' ').join('_');
    return newTag;
  }

  getIdOfferAdd(offer: string): string {
    return `add_${offer.toLowerCase().split(' ').join('_')}`;
  }

  getIdOffer(index: number): string {
    return `offer_${index}`;
  }

  addOrDeleteToMyWish(offer: FullOffer, event: any): void {
    this.authService.refreshToken();
    const { offerKey } = offer;

    if (this.authService.isAuth()) {

      const { sub: userKey } = this.authService.getDecodedToken();
      const wishlistUpdate = new WishList(+userKey, []);

      wishlistUpdate.offerKey = this.myWishes.map(w => w.offerKey);

      const indexOfferInMyWishesUpdate = wishlistUpdate.offerKey.findIndex(o => o === offerKey);

      indexOfferInMyWishesUpdate === -1 ?
        (wishlistUpdate.offerKey.push(offerKey)) :
        (wishlistUpdate.offerKey.splice(indexOfferInMyWishesUpdate, 1));

      this.wishlistService.updateWishList(wishlistUpdate).subscribe({
        next: myWhishes => { this.dataService.myWishes.next(myWhishes); }
      });
    } else {
      const dialogRef = this.dialog.open(OpendialogLoginComponent);

      dialogRef.afterClosed().subscribe({
        next: () => {
          const { sub: userKey } = this.authService.getDecodedToken();
          const wishlistUpdate = new WishList(userKey, []);

          this.myWishes.forEach(wish => {
            wishlistUpdate.offerKey.push(wish.offerKey);
          });

          const indexOfferInMyWishesUpdate = wishlistUpdate.offerKey.findIndex(o => o === offerKey);

          indexOfferInMyWishesUpdate === -1 ?
            (wishlistUpdate.offerKey.push(offerKey)) :
            (wishlistUpdate.offerKey.splice(indexOfferInMyWishesUpdate, 1));

          this.wishlistService.updateWishList(wishlistUpdate).subscribe({
            next: myWhishes => { this.dataService.myWishes.next(myWhishes); }
          });
        }
      });
    }
  }

  isInMyWishes(offerId: string): object {
    const indexOfferInMyWhishes = this.myWishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? this.faHeartEmpty : this.faHeartFull;
  }

  getColorOfHeart(offerId: string): string {
    const indexOfferInMyWhishes = this.myWishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? '#2c296d !important' : '#ff0000';
  }



  openOfferInNewTab(offerKey: number) {
    const { structure, universe } = this.route.snapshot.queryParams;

    const queryParams = {
      offerKey,
      structure,
      universe
    };

    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/home/offer`], {
        queryParams
      })
    );

    window.open(url, '_blank');
  }

  goToUniverseWithQueryParam(universe: number): void {
    if (universe === 5) {
      this.resetSearch();
      this.searchForm.get('slider')?.setValue(50);
    }

    const { structure } = this.route.snapshot.queryParams;

    this.searchTxt = '';
    this.universeSelected = universe;

    if (structure) {
      this.router.navigate(['/home'], {
        queryParams: {
          structure,
          universe
        }
      });

    } else {
      this.subscription.add(
        this.route.queryParams.subscribe(params => {
          if (params.tagKey) {
            this.tagIds = typeof params.tagKey === 'string' ? params.tagKey : params.tagKey.join(';');

            this.router.navigate(['/home'], {
              queryParams: {
                universe,
                tagKey: params.tagKey
              }
            });
          }
          else {

            this.router.navigate(['/home'], {
              queryParams: {
                universe
              }
            });
          }
        })
      );
    }
    universe === 5 ? this.selectDarkTheme() : this.selectLightTheme();
    this.getTags(universe);
  }

  addTag(tag: Tag): void {
    this.tagsSelected.push(tag);
    this.includedTags = true;
    this.initTagsSelected = this.tagsSelected;
    this.dataService.tagSelected$.next(this.tagsSelected);
    sessionStorage.setItem('tags', btoa(JSON.stringify(this.tagsSelected)));
    let allTagSelected: any = [];

    for (const item of this.tagsSelected) {
      const tags = this.baseTags.filter(t => t.tagName.trim() === item.tagName.trim());
      allTagSelected = [...allTagSelected, ...tags];
    }
    allTagSelected = [...new Set(allTagSelected)];

    const tagString = allTagSelected.map(t => t.tagKey).join(';');
    const coordinates = this.formatCoord(this.coordinatesSearch) || '';

    if (this.tagsSelected.length > 0) {
      this.addTagsSelectedAtUrl(this.tagsSelected);

    } else if (this.tagsArray.length > 0) {
      this.router.navigate(['/home'], {
        queryParams: {
          universe: this.universeSelected,
          tagKey: tagString
        }
      });

    } else {
      this.getOfferWithTags(tagString, coordinates);
    }
  }

  private addTagsSelectedAtUrl(tags: Tag[]): void {
    const tagString = tags.map(t => t.tagKey).join(';');
    this.router.navigate(['/home'], {
      queryParams: {
        universe: this.universeSelected,
        tagKey: tagString
      }
    });
  }

  removeTag(tag: Tag): void {
    const index = this.tagsSelected.findIndex(t => t.tagKey === tag.tagKey);
    this.tagsSelected.splice(index, 1);
    this.initTagsSelected = this.tagsSelected;

    if (this.tagsSelected.length === 0) {
      this.tagIds = null;
      this.includedTags = false;
    }
    sessionStorage.setItem('tags', btoa(JSON.stringify(this.tagsSelected)));
    this.dataService.tagSelected$.next(this.tagsSelected);

    const tagString = this.tagsSelected.map(t => t.tagKey).join(';');
    const coordinates = this.formatCoord(this.coordinatesSearch) || '';

    if (this.tagsArray.length > 0) {
      if (this.tagsSelected.length > 0) {
        this.router.navigate(['/home'], {
          queryParams: {
            universe: this.universeSelected,
            tagKey: tagString
          }
        });

      } else {
        this.router.navigate(['/home'], {
          queryParams: {
            universe: this.universeSelected,
          }
        });
        if (typeof this.universeSelected === 'number') {
          this.getOfferWithTags('', '', this.universeSelected);
        }
      }

    } else {
      this.getOfferWithTags(tagString, coordinates);
    }
  }

  clickMoreTag(): void {
    const tags = document.getElementById('tags');
    if (tags) {
      tags.classList.replace('offers_filter_tags_reduce', 'offers_filter_tags_more');
    }
    this.moreTag = true;
  }

  isInTagSelected(tag: string): boolean {
    const index = this.tagsSelected.findIndex(t => t.tagName === tag);
    return index === -1;
  }

  getAddressSearch(event: any): void {
    this.valueInput = this.f.keyword.value;
    this.coordinatesSearch = event;

    this.latitude = event.geometry.location.lat();
    this.longitude = event.geometry.location.lng();

    const cooordinates = this.formatCoord(event);
    const tagString = this.tagsSelected.map(t => t.tagKey).join(';');

    sessionStorage.setItem('coordinates', JSON.stringify(event));

    if (event) {
      this.getOfferWithTags(tagString, cooordinates);
    }

  }

  resetSearch(): void {
    this.f.keyword.reset();
    sessionStorage.removeItem('coordinates');
    this.valueInput = null;
    this.latitude = 0;
    this.longitude = 0;
    this.valueKM = 50;
    if (typeof this.universeSelected === 'number') {
      this.getOfferWithTags('', '', this.universeSelected);
    }

  }

  universIsSelected(indexUniverse: number): boolean {
    const { universe } = this.route.snapshot.queryParams;
    let isSelected = false;

    if (+universe === indexUniverse || (!universe && indexUniverse === 5)) {
      isSelected = true;
    }
    return isSelected;
  }

  getValueColorTag({ colorKey }): string {
    return '#' + this.colorsTag?.find(c => c.colorKey === colorKey)?.value + '!important';
  }

  getValueKM(event: any): void {
    this.valueKM = event.value;
    this.getOffers();
  }

  goBack(value: boolean): void {
    this.isDetailsImageOpen = value;
    this.initComponent();
  }

  private checkDataParam(): void {
    this.subscription.add(
      this.route.queryParams.subscribe(params => {
        if (params.tagKey) {
          this.includedTags = true;
          this.currentDate = moment(new Date()).format('yyyy-MM-DD');
          this.tagIds = typeof params.tagKey === 'string' ? params.tagKey : params.tagKey.join(';');
          localStorage.setItem('tag_club_id', JSON.stringify({ tag: params.tagKey, universe: params.universe }));
          this.getTags(params.universe);
        }
        else {
          localStorage.removeItem('tag_club_id');
        }
      })
    );
  }

  private selectDarkTheme(): void {
    this.document.documentElement.classList.add(OfferHomeComponent.DEMO_THEME_CLASS);
    this.dataService.themeDemo$.next(true);
    this.theme = OfferHomeComponent.DEMO_THEME_DARK;
  }

  private selectLightTheme(): void {
    const user = this.authService.getDecodedToken()?.name;
    if (user?.toLowerCase().includes('demo')) {
      this.selectDarkTheme();
    } else {
      this.document.documentElement.classList.remove(OfferHomeComponent.DEMO_THEME_CLASS);
      this.dataService.themeDemo$.next(false);
      this.theme = OfferHomeComponent.DEMO_THEME_LIGHT;
    }
  }

  private formatCoord(event: any): string {
    this.coordinatesSearch = event;
    const coordinates = [];

    switch (typeof event?.geometry?.location.lat) {
      case 'function':
        coordinates.push(event?.geometry.location.lat().toString().replace('.', ','));
        coordinates.push(event?.geometry.location.lng().toString().replace('.', ','));
        break;

      case 'number':
        coordinates.push(event?.geometry.location.lat.toString().replace('.', ','));
        coordinates.push(event?.geometry.location.lng.toString().replace('.', ','));
        break;

      default:
        break;
    }

    return coordinates.join(';');
  }

  private animationStartOffer(): void {
    let index = 0;
    if (index < 8) {
      setInterval(() => {
        const offer = document.getElementById(`offer_${index}`);
        offer?.classList.remove('offer_start');
        index++;
      }, 300);
    }
  }

  private getOfferWithTags(tagString: string, coordinates: string = '', universeChange?: number, actors?: string): void {
    this.offers = [];
    this.dataService.loadingOfferHome$.next(false);

    const structure = this.route.snapshot.queryParams.structure || '';
    let universe = universeChange ? +universeChange : (+this.route.snapshot.queryParams.universe || '');
    universe === 5 ? this.selectDarkTheme() : this.selectLightTheme();

    this.universeSelected = universe;

    if (!universe) {
      this.universeSelected = 5;
      universe = 5;
    }


    this.offerService.getOfferTag(tagString, coordinates, structure, +universe, actors).subscribe({
      next: offers => {
        this.offers = offers;
        this.listOffers = offers;
        if (universe === 5) {
          this.getOffers();
        } else {
          this.searchTxt ? this.getOffers(this.searchTxt) : this.dataService.offersHome$.next(offers);
        }
        this.dataService.loadingOfferHome$.next(true);
        setTimeout(() => {
          this.animationStartOffer();
        }, 500);
        window.scroll(0, 0);
      }
    });
  }

  private getWishlist(): void {
    const { sub: userKey } = this.authService.getDecodedToken();
    this.wishlistService.getWishList(+userKey).subscribe({
      next: wishes => this.dataService.myWishes.next(wishes)
    });
  }

  private getBasketlist(): void {
    const { sub: userKey } = this.authService.getDecodedToken();
    this.sessionBasketService.getBasketList(+userKey).subscribe({
      next: basket => this.dataService.myShoppingBag.next(basket)
    });
  }

  private getTags(universe: any): void {
    const tempoTag: any = [];
    this.tags = [];
    this.tagsService.getTagsByUniverse(universe).subscribe({
      next: tags => {
        tags.forEach(t => {
          if (t.isActive) {
            t.tags.forEach(tag => {
              tempoTag.push(tag);
            });
          }
        });
        this.baseTags = [...tempoTag];

        for (let i = 1; i < this.colorsTag?.length + 1; i++) {
          const colorOrder = this.colorsTag.find(c => c.order === i);
          const tempo = tempoTag.filter(t => t.colorKey === colorOrder?.colorKey && t.isActive).sort((a, b) => a.tagName.toLowerCase() - b.tagName.toLowerCase());

          tempo.forEach((item: any) => {
            const index = this.tags.findIndex(t => t.tagName.trim() === item.tagName.trim());
            if (index === -1) { this.tags.push(item); }
          });
        }

        if (this.tagIds) {
          this.tagsArray = this.tagIds.split(";").map(Number);
          this.tagsSelected = this.tags.filter(t => this.tagsArray.includes(t.tagKey));
        }
        else if(this.initTagsSelected.length > 0) {
          this.tagsSelected = this.tags.filter(t => this.initTagsSelected.map(ts => ts.tagKey).includes(t.tagKey));
        }

        this.includedTags = this.tags.some(t => this.tagsSelected.map(ts => ts.tagKey).includes(t.tagKey));

        const tagString = this.tagIds ?? (this.includedTags ? this.tagsSelected.map(t => t.tagKey).join(';') : '');

        const coordinates = this.formatCoord(this.coordinatesSearch) || '';

        this.getOfferWithTags(tagString, coordinates, universe);
      }
    });
  }

  private getColorTags(): void {
    this.colorService.getColors().subscribe({
      next: colorsTag => {
        this.colorsTag = colorsTag;
        this.getTags(this.universeSelected);
      }
    });
  }

  private async checkTagSelected(universe: number) {
    let tagString = ' ';

    if (sessionStorage.getItem('tags')) {

      this.dataService.tagSelected$.next(this.tagsSelected);

      tagString = await this.tagsSelected.length ? this.tagsSelected.map(t => t.tagKey).join(';') : ' ';
    }

    let coordinates;
    if (sessionStorage.getItem('coordinates')) {
      const event = await JSON.parse(sessionStorage.getItem('coordinates'));
      coordinates = await event ? this.formatCoord(event) : '';
    }

    if (this.tagIds) {
      this.getOfferWithTags(this.tagIds, '', universe);
    }
    else {
      sessionStorage.getItem('tags') || sessionStorage.getItem('coordinates') ?
        this.getOfferWithTags(tagString, coordinates) :
        this.getOfferWithTags(' ');
    }


  }

  get f() {
    return this.searchForm.controls;
  }

  private getListOffers(offersFilter: any, offersList: FullOffer[]): FullOffer[] {
    let offers: FullOffer[] = [];
    offersList.forEach(offer => {
      offersFilter.forEach((o: any) => {
        if (offer.offerKey === o.key) {
          offer.startDate = o.startDate;
          offers.push(offer);
        }
      });
    });
    offers.sort((x, y) => moment(x.startDate).toDate().getTime() > moment(y.startDate).toDate().getTime() ? 1 : -1);
    return offers;
  }

  private getOffers(text?: string): void {
    let offersFilter: any;

    if (this.universeSelected === 5) {
      const params = {
        date: this.currentDate,
        text: this.searchTxt,
        distance: this.valueKM < 205 ? this.valueKM * 1000 : undefined,
        lat: this.latitude,
        lng: this.longitude,
        tags: this.tagIds
      };
      this.offerService.getOffersByFilter(params).subscribe({
        next: datas => {
          offersFilter = datas;
          this.dataService.offersHome$.next(this.getListOffers(offersFilter, this.listOffers));
          this.isLoading = false;
        }
      });

    } else if (text) {
      this.offerService.getOffersByText(text).subscribe({
        next: datas => {
          offersFilter = datas;
          this.dataService.offersHome$.next(this.getListOffers(offersFilter, this.listOffers));
          this.isLoading = false;
        }
      });
    }
  }

  private initForm(): void {
    let coordinates = null;

    if (sessionStorage.getItem('coordinates')) {
      coordinates = JSON.parse(sessionStorage.getItem('coordinates'));
      if (coordinates) {
        this.valueInput = coordinates.name;
      }
    }

    this.searchForm = this.formBuilder.group({
      keyword: [coordinates?.name || '', Validators.required],
      startDate: [this.currentDate, Validators.required],
      km: [this.valueKM],
      search: [null],
      slider: [{ value: this.valueKM, disabled: true}]
    });

    this.searchForm.get('startDate').valueChanges.subscribe(value => {
      if (value) {
        if (value.year() >= 2000 && value.year() < 9999 ) {
          this.currentDate = value.format('yyyy-MM-DD');
          this.getOffers();
        } else {
          this.uiService.showSnackbar(`Veuillez saisir une année entre 2000 et 9999.`);
        }
      }
      else { return; }
    });

    this.searchForm.get('keyword').valueChanges.subscribe(value => {
      if (value) {
        this.searchForm.get('slider').enable();
      } else {
        this.searchForm.get('slider').disable();
      }
    });

    this.searchForm.get('search').valueChanges.subscribe(value => {
      if (value.length > 2) {
        this.searchTxt = value;
        if (this.universeSelected === 5) {
          this.getOffers();

        } else {
          this.getOffers(value);
        }

      } else {
        this.searchTxt = null;
        if (this.universeSelected === 5) {
          this.getOffers();
        } else {
          this.dataService.offersHome$.next([]);
        }
      }
    });
  }

  private initComponent(): void {
    this.currentDate = moment(new Date()).format('yyyy-MM-DD');
    this.dataService.tabHome$.next('home');
    this.dataService.titleHomePage.next('Trouver un article');
    this.dataService.resetPopUp();
    this.tagsSelected = [];
    let universe = 5;
    if (this.route.snapshot.queryParams.universe) {
      universe = Number.parseInt(this.route.snapshot.queryParams.universe);
    }
    this.universeSelected = universe;

    if (sessionStorage.getItem('tags') && sessionStorage.getItem('tags') === 'W10=') {
      sessionStorage.removeItem('tags');
      this.tagsSelected = [];
    }

    this.isLoading = true;
    this.universeService.getUniverse().subscribe({
      next: data => {
        this.listUniverses = data;
        if (!this.tagIds) {
          this.offerService.getOfferTag('', '', '', universe).subscribe({
            next: offers => {
              this.listOffers = offers;
              this.offers = offers;
              this.dataService.offersHome$.next(offers);
              this.dataService.loadingOfferHome$.next(true);

              if (this.universeSelected === 5) {
                this.getOffers();
              } else {
                this.isLoading = false;
              }
              setTimeout(() => {
                this.animationStartOffer();
              }, 500);
              window.scroll(0, 0);
            }
          });
        } else {
          this.isLoading = false;
        }

      },
      error: () => this.isLoading = false
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.myWishes.asObservable().subscribe({
          next: myWishes => { this.myWishes = myWishes; this.cdr.detectChanges(); }
        })
      )
      .add(
        this.authService.currentUser.subscribe({
          next: user => {
            this.userConnected = user;
          }
        })
      )
      .add(
        this.dataService.offersHome$.subscribe({
          next: offers => {
            this.offers = offers;

            setTimeout(() => {
              this.animationStartOffer();
            }, 500);
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.tagSelected$.subscribe({
          next: tags => {
            this.tagsSelected = tags;
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.loadingOfferHome$.subscribe({
          next: load => {
            this.load = load;
            this.cdr.detectChanges();
          }
        })

      .add(
        this.noticeService.detailsImage$.subscribe(data => {
          this.notice = data.notice;
          this.isDetailsImageOpen = data.bool;
          if (!this.isDetailsImageOpen) {
            this.initComponent();
          }
        })
      )
      );


  }

  openDialogHelp() {
    this.dialog.open(OpenDialogHelpComponent, {
      data: { helpVideoKey: 1 },
      width: '60%',
      maxHeight: '90%'
    });
  }

  resetFilter() {
    sessionStorage.removeItem('clubCodeForHomeOffers');
    this.filteredByClub = false;

    this.resetSearch();
  }
}

